import {Component, Injector} from '@angular/core';
import {ApiResponse} from '../../../../../Services/Api/base-api.service';
import {WidgetDataControllerComponent} from '../../../../Controller/widget-data-controller-component';
import {OrdersApiService} from '../../../../../Services/Api/Purchases/Orders/orders-api.service';
import {OrderDto} from '../../../../../Models/Purchases/Orders/order.interface';
import {OrderStatusEnum} from '../../../../../Shared/Enum/order-status.enum';

@Component({
  selector: 'app-not-sent-orders-widget',
  templateUrl: './not-sent-orders-widget.component.html',
  styleUrls: ['./not-sent-orders-widget.component.scss'],
  standalone: false
})
export class NotSentOrdersWidgetComponent extends WidgetDataControllerComponent<number> {

  override fakeData: number = 12;

  get widgetData(): number {
    return this.data || this.data === 0 ? this.data : this.fakeData;
  }

  constructor(
    protected override injector: Injector,
    protected ordersService: OrdersApiService,
  ) {
    super(injector, ordersService);
  }


  /**
   * Obtener los pedidos sin enviar
   *
   */
  override setData(data: OrderDto[]) {
    const localFilter: number = this.widgetsManager.filters?.local.id || 0;

    if (localFilter) {
      data = data.filter((item) => item.id_local === localFilter);
    }

    const dataAux: OrderDto[] = data.filter((item) => item.id_estado === OrderStatusEnum.pendent) || [];
    this.data = dataAux.length;
  }


  /**
   * Obtener datos
   *
   */
  getData(): Promise<ApiResponse> {
    return this.ordersService.getOrders();
  }

}
